<template>
  <div class="proposta-anexos">
    <h2>
      Listagem de parcelas da proposta n° {{ proposta.municipioPropostaId }}
    </h2>

    <hr />

    <v-data-table
      :headers="headersMinuta"
      :items="parcelas"
      class="elevation-1 w-100 proposta-anexos__table"
      hide-default-footer
      disable-pagination
      item-key="municipioPropostaId"
      fixed-header
      height="530"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <template v-for="(item, index) in items">
            <!-- Linha principal -->
            <tr>
              <td>{{ item.parcela }}</td>
              <!-- Supondo que um campo nome exista -->
              <td>
                {{
                  item.valor.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{ item.dataVencimento | moment("DD/MM/YYYY") }}
              </td>
              <td>
                <v-autocomplete
                  id="temas-select"
                  v-model="item.municipioPropostaParcelasStatusId"
                  :items="status"
                  label="Status"
                  placeholder="Selecione..."
                  item-text="nome"
                  item-value="municipioPropostaParcelaStatusid"
                >
                  <template slot="no-data"> Nenhum Status retornado </template>
                </v-autocomplete>
              </td>

              <td>
                <div
                  v-if="diasAtraso(item.dataVencimento) > 0 && item.status != 3"
                >
                  {{ diasAtraso(item.dataVencimento) }}
                </div>
              </td>
            </tr>

            <!-- Linha de ações abaixo -->
            <tr>
              <td colspan="7">
                <v-textarea
                  label="Observações"
                  v-model="item.observacoes"
                ></v-textarea>
                <div class="d-flex mt-2 mb-4" style="justify-content: flex-end">
                  <v-btn
                    color="primary"
                    class="ml-3"
                    @click="salvarParcela(item)"
                  >
                    <span>Salvar parcela {{ item.parcela }}</span>
                  </v-btn>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="7">
                <div class="proposta-anexos__anexos mb-4 mt-3">
                  <h4>Ações da parcela {{ item.parcela }}</h4>
                  <div class="proposta-anexos__anexos__add">
                    <NovoAnexo :payload="item" @reload="load">
                      <template v-slot:title>
                        Adicionar ação na parcela {{ item.parcela }}
                      </template>
                    </NovoAnexo>
                  </div>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="item.municipioPropostaParcelasAnexosDTO"
                  class="elevation-1 w-100 proposta-anexos__table mb-4"
                  hide-default-footer
                  disable-pagination
                  item-key="municipioPropostaId"
                >
                  <template v-slot:item.download="{ item }">
                    <v-btn
                      color="primary"
                      class="mr-3"
                      @click="downloadAnexos(item)"
                    >
                      Download Ação
                    </v-btn>
                  </template>
                  <template v-slot:item.acoes="{ item }">
                    <ModalDeleteAnexo :payload="item" @reload="load">
                      <template v-slot:title> Deletar Ação </template>
                    </ModalDeleteAnexo>
                  </template>
                </v-data-table>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import ModalDeleteAnexo from "./modalDeleteAcao.vue";
import NovoAnexo from "./NovaAcao.vue";
import { mapActions, mapGetters } from "vuex";
import {
  municipioPropostaParcelasAnexoAPI,
  municipioPropostaParcelasStatus,
  municipioPropostaParcelasApi,
} from "@/apis/proposta";
import moment from "moment";
import promiseAllSettledPollyfill from "@/helpers/promiseConvertes";
export default {
  name: "AnexosList",
  components: {
    NovoAnexo,
    ModalDeleteAnexo,
  },
  props: {
    payload: { type: Object, required: true },
    municipio: { type: Object, required: true },
  },
  watch: {
    payload: {
      handler(val) {
        this.proposta = val;
        this.minutas = [
          {
            nomeDoArquivo: val.nomeArquivo,
            municipioPropostaId: val.municipioPropostaId,
            dataCriacao:
              val.dataEnvioMinuta &&
              moment(val.dataEnvioMinuta).format("DD/MM/YYYY"),
          },
        ];
      },
      deep: true,
    },
  },
  data() {
    return {
      proposta: this.payload,
      minutas: [
        {
          nomeDoArquivo: this.payload.nomeArquivo,
          municipioPropostaId: this.payload.municipioPropostaId,
          dataCriacao:
            this.payload.dataEnvioMinuta &&
            moment(this.payload.dataEnvioMinuta).format("DD/MM/YYYY"),
        },
      ],
      parcelas: [],
      acoes: [],
      status: [],
      headers: [
        { text: "Nome", value: "nomeArquivo" },
        { text: "Descrição", value: "descricao" },
        {
          text: "Download",
          value: "download",
          width: "10%",
          align: "center",
          sortable: false,
        },

        {
          text: "Excluir",
          value: "acoes",
          align: "center",
          width: "10%",
          sortable: false,
        },
      ],
      headersMinuta: [
        { text: "Número", value: "parcela", width: "10%" },
        { text: "Valor", value: "valor", width: "10%" },
        {
          text: "Vencimento",
          value: "dataVencimento",
          width: "15%",
        },
        { text: "Status", value: "status" },
        { text: "Atraso", value: "atraso", width: "10%" },
      ],
    };
  },
  computed: {
    ...mapGetters(["user"]),

    anexos() {
      if (
        this.payload &&
        this.payload.municipioPropostaAnexoDTO &&
        this.payload.municipioPropostaAnexoDTO.length > 0
      )
        return this.payload.municipioPropostaAnexoDTO.map((item) => ({
          nomeDoArquivo: item.nomeArquivo,
          description: item.descricao,
          dataCriacao: moment(item.createdAt).format("DD/MM/YYYY"),
          municipioPropostaAnexosId: item.municipioPropostaAnexosId,
        }));

      return [];
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    fazerDownloadRelatorio(file, nomeArquivo) {
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${nomeArquivo}`);
      fileLink.target = "_blank";
      document.body.appendChild(fileLink);
      fileLink.click();
      this.setLoading(false);
    },
    diasAtraso(data) {
      if (data) {
        const dataVencimento = moment(data);
        const hoje = moment();
        return hoje.diff(dataVencimento, "days");
      }
      return 0;
    },
    salvarParcela(item) {
      this.setLoading(true);
      const parcela = {
        ...item,
        dataVencimento: moment(item.dataVencimento).format("YYYY-MM-DD"),
      };

      municipioPropostaParcelasApi
        .update(parcela)
        .then((_) => {
          this.setLoading(false);

          this.$notification.success("Parcela salva com sucesso");
          this.$emit("onLoad");
        })
        .catch((err) => {
          this.setLoading(false);
          this.$notification.error("Erro ao salvar a parcela");
          console.log("Erro no salvar parcela ", err);
        });
    },
    downloadAnexos(item) {
      this.setLoading(true);
      municipioPropostaParcelasAnexoAPI
        .downloadAnexo(item.municipioPropostaParcelaAnexoId)
        .then((data) => {
          this.fazerDownloadRelatorio(
            data.data,
            `Ação ${item.municipioPropostaParcelasId} - ${item.nomeArquivo}`
          );

          this.$emit("onLoad");
        })
        .catch((err) => {
          this.$notification.error("Erro ao fazer download do anexo");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    deletarAcao(item) {},
    async getStatus() {
      return await municipioPropostaParcelasStatus.list();
    },
    async getParcelas() {
      return await municipioPropostaParcelasApi.getPorPropostasId(
        this.proposta.municipioPropostaId
      );
    },
    load() {
      this.setLoading(true);

      Promise.allSettled([this.getStatus(), this.getParcelas()]).then(
        (results) => {
          this.setLoading(false);
          results.forEach((result, idx) => {
            if (result.status == "fulfilled") {
              if (idx == 0) {
                this.status = result.value.data;
              }
              if (idx == 1) {
                this.parcelas = result.value.data.map((item) => {
                  return {
                    ...item,
                    dataVencimento: moment(item.dataVencimento).format(
                      "YYYY-MM-DD"
                    ),
                  };
                });
                console.log("Parcelas carregadas", this.parcelas);
              }
            } else {
              this.$notification.error(
                "Erro ao carregar os dados das parcelas"
              );
              console.log("Erro no carregar status ", result);
            }
          });
        }
      );
    },
  },

  mounted() {
    promiseAllSettledPollyfill();
    this.load();
  },
};
</script>
<style lang="scss">
.proposta-anexos {
  &__table {
    th {
      background-color: #6c6b6b !important;
      padding: 0 10px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.nomeEvidencia {
  cursor: pointer;
  color: #2d6189;
  font-weight: bold;
}

.nomeEvidencia:not(:last-of-type) {
  border-right: 1px solid #dfdfdf;
  padding-right: 20px;
}

.agrupEvidencias {
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.proposta-anexos {
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 20px;

  &__anexos {
    display: flex;
    column-gap: 10px;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    &__add {
      margin-left: auto;
    }
  }
  &__enviar {
    display: flex;
    column-gap: 10px;
    padding: 10px;
    align-items: center;
    width: 100%;
    max-width: 600px;
    margin-left: auto;
  }
}
</style>
